import { ONLY_NUM_ALLOWED } from "react-common-ui-library";

export const VERIFY_ACCOUNT_BACK_BUTTON_ID = "verify-account-back-button";
export const VERIFY_ACCOUNT_HEADER_ID = "verify-account-header";
export const VERIFY_ACCOUNT_BACK_BUTTON = "verify-account-back-button";
export const REGISTER_VERIFICATION_METHOD_ROUTE =
  "/register-verification-method";
export const VERIFY_ACCOUNT_EMAIL_HEADER = "verify-account-email-header";
export const VERIFY_ACCOUNT_PHONE_HEADER = "verify-account-phone-header";
export const PREFERRED_METHOD_EMAIL = "email";
export const PREFERRED_METHOD_PHONE = "phone";
export const ALTERNATE_MODE_LINK_ID = "verify-account-other-mode-link";
export const ALTERNATE_METHOD_PHONE_LINK =
  "verify-account-alternative-method-phone-link";
export const ALTERNATE_METHOD_EMAIL_LINK =
  "verify-account-alternative-method-email-link";
export const VERIFY_ACCOUNT_FORM = "verify-account-form";
export const VERIFY_ACCOUNT_OTP_LABEL = "verify-account-otp-label";
export const VERIFY_ACCOUNT_OTP_LABEL_EMAIL = "verify-account-otp-label-email";
export const VERIFY_ACCOUNT_OTP_LABEL_EMAIL_ADDRESS =
  "verify-account-otp-label-email-address";
export const VERIFY_ACCOUNT_OTP_LABEL_PHONE = "verify-account-otp-label-phone";
export const VERIFY_ACCOUNT_OTP_LABEL_PHONE_NUMBER =
  "verify-account-otp-label-phone-number";
export const VERIFY_ACCOUNT_FORM_NAME = "otp";
export const VERIFY_ACCOUNT_CODE_NOT_RECEIVED =
  "verify-account-code-not-received";
export const RESEND_CODE_LINK = "resend-code-link";
export const VERIFY_ACCOUNT_RESEND_CODE_LINK =
  "verify-account-resend-code-link";
export const VERIFY_CODE_BUTTON = "verify-account-verify-code-button";
export const CANNOT_CONFIRM_ACCOUNT_MODAL = "cannot-confirm-account-modal";
export const CANNOT_CONFIRM_ACCOUNT_TITLE =
  "cannot-confirm-account-modal-title";
export const CANNOT_CONFIRM_ACCOUNT_OK_BTN =
  "cannot-confirm-account-modal-ok-button";
export const CANNOT_CONFIRM_ACCOUNT_CONTENT =
  "cannot-confirm-account-modal-content";
export const ACCOUNT_CREATION_FAILED_MODAL = "account-creation-failed-modal";
export const ACCOUNT_CREATION_FAILED_TITLE =
  "account-creation-failed-modal-title";
export const ACCOUNT_CREATION_FAILED_OK_BTN =
  "account-creation-failed-modal-ok-button";
export const ACCOUNT_CREATION_FAILED_CONTENT =
  "account-creation-failed-modal-content";
export const OTP_VALIDATION_LIMIT_EXHAUSTED = "OTP_VALIDATION_LIMIT_EXHAUSTED";
export const INVALID_OTP = "INVALID_OTP";
export const USER_ACTION_VERIFY = "verify";
export const USER_ACTION_RESEND = "resend";
export const RESEND_OTP_LIMIT_EXHAUSTED = "OTP_SENT_AND_RESEND_LIMIT_EXHAUSTED";
export const CONSUMER_RESEND_OTP_LINK_HELPER_TEXT =
  "verify-account-resend-link-helper-text";
export const LOGIN_RESEND_OTP_LINK_HELPER_TEXT =
  "verify-account-resend-link-login-helper-text";
export const MANUAL = "manual";
export const VERIFY_ACCOUNT_OTP_FORM = "otp";
export const ACCOUNT_CREATED = "ACCOUNT_DETAILS_SUCCESSFULLY_UPDATED";
export const OTP_INVALID_ERROR = "verify-account-otp-invalid-error";
export const OTP_SENT_SUCCESSFULLY = "OTP_SENT_SUCCESSFULLY";
export const EMAIL_ADDRESS = "email-address";
export const PHONE_NUMBER = "phone-number";
export const VERIFY_ACCOUNT_RESEND_CODE_HELPER_TEXT =
  "verify-account-resend-code-helper-text";
export const VALID_OTP = "VALID_OTP";
export const MFA_METHOD_REGISTRATION_SUCCESSFUL =
  "MFA_METHOD_REGISTRATION_SUCCESSFUL";
export const USER_ENABLE_SUCCESS = "USER_ENABLE_SUCCESS";
export const VERIFY_ACCOUNT_USER_ACTION_VERIFY = "verify";
export const ADD_OR_EDIT_VERIFICATION = "add-or-edit-verification";
export const ACTION_REGISTER = "register";
export const SEND_OTP_DESCRIPTION = "sendOTPDescription";
export const IS_ACCOUNT_BLOCKED = "isAccountBlocked";

export const isValidOTP = (value) => {
  const invalidChar = !ONLY_NUM_ALLOWED.test(value);
  if (value && (invalidChar || value.length !== 6)) {
    return OTP_INVALID_ERROR;
  }
  return true;
};
